<template>
    <v-dialog
      v-model="visible"
      persistent
      width="500">

      <v-card>
        <v-card-title class="text-h5 primary">
          <p style="color: #ffffff">{{ dialog.title }}</p>
        </v-card-title>

        <v-card-text>
          {{  dialog.message }} 
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeBeforeLaunchDialog(dialog)"
          >
          OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
const EVENT_NAME = "close-before-launch-dialog";
export default {
  props: {
    value: Boolean,
    dialog: {
      type: Object,
      required: true
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit(EVENT_NAME);
      },
    },
  },
  methods: {
    closeBeforeLaunchDialog: function (dialog) {
      if (dialog.canDismiss) {
        this.$emit(EVENT_NAME);
      }
    },
  },
};
</script>
